module.exports = __webpack_public_path__ + "img/Pusan2.3b130dcd.jpg";